import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../services/api";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Form,
  FormFeedback,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Import Home Button
import AccountHomeButton from "../pages/Auth/account-home-button";

const EmployeeLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("bg-account-pages", "py-4", "py-sm-0");
    document.getElementById("colorTheme").setAttribute("href", "assets/colors/red.css");

    return () => {
      document.body.classList.remove("bg-account-pages", "py-4", "py-sm-0");
      document.getElementById("colorTheme").setAttribute("href", "assets/colors/cyan.css");
    };
  }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Please Enter Your Email"),
      password: Yup.string().min(6, "Password must be at least 6 characters").required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      try {
        const { data } = await api.post("/emp-login", values);

        if (data.accessToken) {
          api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
          alert("Logged in successfully!");
          navigate("/emp-dashboard");
        } else {
          alert(data.message);
          navigate("/emp-otp", { state: { userId: data.userId } });
        }
      } catch (err) {
        alert("Login failed.");
      }
    },
  });

  return (
    <React.Fragment>
      {/* Home Button */}
      <AccountHomeButton />

      <section className="vh-100">
        <div className="display-table">
          <div className="display-table-cell">
            <Container>
              <Row className="justify-content-center">
                <Col lg="5">
                  <Card className="account-card">
                    <CardBody>
                      {/* First Time User Button */}
                      <div className="d-flex emp-login-header">
                        <h4 className="font-weight-bold">
                            <i className="mdi mdi-account "></i> Employee Login
                          
                        </h4>
                        </div>
                        <div>
                        <Button
                          color="link"
                          className="text-primary"
                          onClick={() => navigate("/emp-register")}
                        >
                          First Time User?
                        </Button>
                      </div>
                      <p className="text-muted text-center">Sign in to continue.</p>

                      <div className="p-4">
                        <Form onSubmit={validation.handleSubmit}>
                          <div className="form-group">
                            <Label for="email">Email</Label>
                            <Input
                              name="email"
                              placeholder="Enter Email"
                              type="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={validation.touched.email && validation.errors.email ? true : false}
                            />
                            {validation.touched.email && validation.errors.email ? (
                              <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="form-group mt-3">
                            <Label for="password">Password</Label>
                            <Input
                              name="password"
                              placeholder="Enter password"
                              type="password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.password || ""}
                              invalid={validation.touched.password && validation.errors.password ? true : false}
                            />
                            {validation.touched.password && validation.errors.password ? (
                              <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="d-grid mt-3">
                            <Button type="submit" className="btn btn-primary">
                              Log In
                            </Button>
                          </div>

                          <div className="mt-4 mb-0 text-center">
                            <Link to="/forgotpasswordemp" className="text-dark">
                              <i className="mdi mdi-lock"></i> Forgot your password?
                            </Link>
                          </div>
                        </Form>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default EmployeeLogin;
